'use strict';

var reactIs = {exports: {}};

exports.__module = reactIs;
//# sourceMappingURL=index4.cjs.map
